let cachedResults = null;

// pgw 03-apr-2025
let doprint = false;



// pgw 30-mar-2025 add random query string as cache-buster
function cacheBustingUrl(url) {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}cb=${Date.now()}`;
}


export async function fetchLibrarySongs(startIndex, limit, searchTerm, activeFilters, clientConfig) {
  try {
      let songsJson;

		if (doprint) console.log("pgw fetchLibrarySongs startIndex = ", startIndex); 
		if (doprint) console.log("pgw fetchLibrarySongs limit = ", limit); 
		if (doprint) console.log("pgw fetchLibrarySongs searchTerm = ", searchTerm); 

		// pgw 04-apr-2023 test with timeout of 20 seconds
	  //   const response = await fetch(clientConfig.features.library.endpoint);


		// pgw 30-mar-2025 add random query string as cache-buster
		// const response = await fetch(clientConfig.features.library.endpoint, { timeout: 20000 });


		// pgw 15-aug-2025 - remove cache bust call for now (so that songlist can be cached for offline)
	  // const uniqueEndpoint = cacheBustingUrl(clientConfig.features.library.endpoint)
	  const uniqueEndpoint = clientConfig.features.library.endpoint

		if (doprint) console.log("pgw clientConfig.features.library.endpoint = ", clientConfig.features.library.endpoint); 
		if (doprint) console.log("pgw uniqueEndpoint = ", uniqueEndpoint); 

      const response = await fetch(uniqueEndpoint, { timeout: 20000 });
      if (response.status === 200) {
        songsJson = await response.json();
      } else {
        throw new Error('Library request failed');
      }
    
      let songs = Array.from(new Set(songsJson));
      songs = songs.filter(song => song.songId !== 's3fm0063_0301'); // filer out the odd duplicate in the reponse
      
      //temporary filter to exclude songs that dont play
      songs = songs.filter(song => !clientConfig.features.library.songsToHide.includes(song.songId));

      // songs = songs.sort((a,b)=> { 
      //   return config.WORKING_ON_IOS.indexOf(b.songId) - config.WORKING_ON_IOS.indexOf(a.songId)
      // });

      if (searchTerm) {
        songs = songs.filter(song => (song.artist.toLowerCase().includes(searchTerm) || song.mix.toLowerCase().includes(searchTerm) || song.songId === searchTerm))
      }
      if (activeFilters) {
        if (activeFilters.genres.length) {
          songs = songs.filter(song => activeFilters.genres.includes(song.genre));
        }
        if (activeFilters.keySignatures.length) {
          songs = songs.filter(song => activeFilters.keySignatures.includes(song.key));
        } 
        if (activeFilters.decades.length) {
          songs = songs.filter(song => activeFilters.decades.includes(song.decade));
        }
      }

      return {
        data: songs.slice(startIndex, limit)
      };
      
        
      
    
  } catch (e) {
    console.error(e);
    throw new Error(e.message);
  }
}

export async function fetchLibrarySongsById(songIds, clientConfig) {
  try {

	// pgw 30-mar-2025 add random query string as cache-buster
	if (doprint) console.log("pgw fetchLibrarySongsById cachedResults = ", cachedResults); 

    if (!cachedResults) {
	// pgw 04-apr-2023 test with timeout of 20 seconds
//       const response = await fetch(clientConfig.features.library.endpoint);
      const response = await fetch(clientConfig.features.library.endpoint, { timeout: 20000 });
      if (response.status === 200) {
        cachedResults = await response.json();
      } else {
        throw new Error('Library request failed');
      }
    }
      let songs = Array.from(new Set(cachedResults));
      
      let results = [];
      
      //temporary filter to exclude songs that dont play
      songs = songs.filter(song => !clientConfig.features.library.songsToHide.includes(song.songId));

      for (const id of songIds) {
        const foundSong = songs.find(s => s.songId === id);
        if (foundSong) {
          results.push(foundSong);
        }
      }

      return {
        data: results
      };    
  } catch (e) {
    console.error(e);
    throw new Error(e.message);
  }
}
